import React from 'react';
import { trackPixelEvent } from '../lib/metaPixel';
export function Header() {
  return <header className="sticky top-0 z-50 w-full bg-cream/90 backdrop-blur-md border-b border-taupe/30 transition-all duration-300" data-id="element-182">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-14 flex items-center justify-between" data-id="element-183">
        <div className="flex items-center" data-id="element-184">
          <span className="font-serif font-bold text-forest text-lg tracking-tight" data-id="element-185">
            Rylte Health
          </span>
        </div>
        <div className="hidden sm:flex items-center" data-id="element-186">
          <span className="text-[10px] uppercase tracking-widest text-ink/40 font-medium" data-id="element-187">
            Advertorial
          </span>
        </div>
        <div className="flex items-center" data-id="element-188">
          <a href="https://rylte.com/products/nerva" target="_blank" rel="noopener noreferrer" onClick={() => trackPixelEvent('ViewContent', {
          content_name: 'Nerva',
          content_category: 'Cervical Vagal Restoration Device',
          content_ids: ['nerva'],
          content_type: 'product',
          source: 'header'
        })} className="text-sm font-medium text-forest hover:text-sage transition-colors duration-200" data-id="element-189">
            Learn About Nerva™
          </a>
        </div>
      </div>
    </header>;
}